import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonLoading,
  IonPage,
  IonTitle,
  IonToolbar,
  useIonRouter,
} from '@ionic/react'
import { useParams } from 'react-router-dom'

import { ImglyEditor } from '../../../integrations/imgly/components/imgly-editor'
import { useUpdateBroadcast } from '../../../marketing/broadcasts/mutations'
import { useBroadcastDetail } from '../../../marketing/broadcasts/queries'

function ImglyPage() {
  const { broadcastId } = useParams<{ broadcastId: string }>()

  const router = useIonRouter()

  const broadcast = useBroadcastDetail(broadcastId)
  const updateBroadcast = useUpdateBroadcast()

  function handleSave(imglyString: string) {
    updateBroadcast.mutate(
      {
        objectId: broadcastId,
        broadcast: { imglyString },
        isPartial: true,
      },
      {
        onSuccess: () =>
          router.canGoBack()
            ? router.goBack()
            : router.push(`/admin/campaigns/broadcast/${broadcastId}`, 'back'),
      }
    )
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              color="secondary"
              defaultHref={`/admin/campaigns/broadcast/${broadcastId}`}
              text="Cancel"
            />
          </IonButtons>

          <IonTitle>
            <h2 className="text-xl capitalize">Design</h2>
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className="relative flex h-full flex-col">
          <div className="relative flex-shrink-0 flex-grow">
            <ImglyEditor
              initialScene={broadcast.data?.imglyString}
              onSave={handleSave}
            />
          </div>
        </div>
      </IonContent>

      <IonLoading
        isOpen={updateBroadcast.isLoading}
        message="Updating broadcast..."
      />
    </IonPage>
  )
}

export { ImglyPage }
